import React, { memo } from 'react';
import styled from 'styled-components';
import { RECEPTION_STATUS_LABEL, getReceptionStatusColor } from '../utils/utils';

import type { CheckInListItemDtoStatus } from '@/api/generated/model';

type ReceptionStatusBadgeProps = {
	status: CheckInListItemDtoStatus;
};

// 리셉션 진행 상태 배지 (대회 진행중 / 대회 준비중)
const ReceptionStatusBadge = memo<ReceptionStatusBadgeProps>(({ status }) => {
	const { fontColor, bgColor } = getReceptionStatusColor(status);

	return (
		<Wrapper $fontColor={fontColor} $bgColor={bgColor}>
			{RECEPTION_STATUS_LABEL[status]}
		</Wrapper>
	);
});

ReceptionStatusBadge.displayName = 'ReceptionStatusBadge';

export default ReceptionStatusBadge;

const Wrapper = styled.div<{ $fontColor: string; $bgColor: string }>`
	height: 24px;
	${({ theme }) => theme.typography.caption};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0 10px;
	border-radius: 4px;
	white-space: nowrap;
	color: ${({ $fontColor }) => $fontColor};
	background-color: ${({ $bgColor }) => $bgColor};
`;
